

























































































import Vue, { PropType } from 'vue';
// import * as firebase from '@/plugins/firebase';
import { firebase } from 'mostra';

export default Vue.extend({
  name: 'GBuyerDrawerMenu',
  model: {
    prop: 'show',
    event: 'toggle',
  },
  props: {
    show: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  computed: {
    isExhibitor(): boolean {
      return this.$auth.isExhibitor;
    },
    isBuyer(): boolean {
      return this.$auth.isBuyer;
    },
    isShow: {
      get(): boolean {
        return this.show;
      },
      set(val: boolean): void {
        this.$emit('toggle', val);
      },
    },
  },
  methods: {
    async onSignOut(event: Event) {
      event.preventDefault();
      try {
        await firebase.auth().signOut();
        window.location.href = '/';
      } catch (error: any) {
        this.$fatal(error);
      }
    },
    closeMenu() {
      this.$emit('close');
    },
  },
});
